import React, { useEffect, useState, useMemo } from 'react';
import SelectableFilterItem from '../../../../elements/SelectableFilterItem/SelectableFilterItem';
import CollapsableCategory from '../../../../elements/CollapsableCategory/CollapsableCategory';
import { max } from 'lodash';

const SAVED_EXPANDED_CATEGORIES = {};

function DirectoryFilterTagCategory(props) {
    const { category, filterParams, onSelectionChange, defaultExpanded } = props,
        [expanded, setExpanded] = useState(SAVED_EXPANDED_CATEGORIES[category.name] ?? defaultExpanded ?? false),
        maxCount = useMemo(() => max(category.options.map((o) => o.count)), [category.options]);

    // Save state
    useEffect(() => {
        return () => (SAVED_EXPANDED_CATEGORIES[category.name] = expanded);
    }, [expanded]);

    return (
        <CollapsableCategory
            title={category.title || category.name}
            flagColor={category.color}
            expanded={expanded}
            disabled={!category.options.length}
            key={category.name}
            onChange={(expanded) => setExpanded(expanded)}>
            {category.subtitle ? <div>{category.subtitle}</div> : null}
            <div>
                {category.options.map((option) => {
                    const checked = filterParams.tags?.[category.name]?.includes(option.name);
                    return (
                        <SelectableFilterItem
                            key={option.name}
                            color={option.color}
                            count={option.count}
                            percentage={maxCount ? option.count / maxCount : 0}
                            iconCount="img/member.png"
                            checked={checked}
                            onChange={(checked) => onSelectionChange(category, option, checked)}>
                            {option.name}
                        </SelectableFilterItem>
                    );
                })}
            </div>
        </CollapsableCategory>
    );
}

export default DirectoryFilterTagCategory;
